import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const BulkActionsBar = ({ selectedCount, onExtendSelected, onCloseSelected, onExportSelected, onClearSelection }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-card border border-border rounded-lg shadow-lg p-4 flex items-center gap-4">
      <div className="flex items-center gap-2">
        <Icon name="CheckSquare" size={20} className="text-primary" />
        <span className="text-sm font-medium text-foreground">
          {selectedCount} permit{selectedCount !== 1 ? 's' : ''} selected
        </span>
      </div>

      <div className="h-6 w-px bg-border" />

      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          iconName="Clock"
          onClick={onExtendSelected}
        >
          Extend
        </Button>

        <Button
          variant="outline"
          size="sm"
          iconName="XCircle"
          onClick={onCloseSelected}
        >
          Close
        </Button>

        <Button
          variant="outline"
          size="sm"
          iconName="Download"
          onClick={onExportSelected}
        >
          Export
        </Button>

        <Button
          variant="ghost"
          size="sm"
          iconName="X"
          onClick={onClearSelection}
        >
          Clear
        </Button>
      </div>
    </div>
  );
};

export default BulkActionsBar;